import React, { useState } from "react";
import "../styles/enterpriseSolutions.css";
//importing Images for services
import image01 from "../assets/svgs/enterprise-solution-svgs/image01.jpg";
import image02 from "../assets/svgs/enterprise-solution-svgs/image02.jpg";
import image03 from "../assets/svgs/enterprise-solution-svgs/image03.jpg";
import image04 from "../assets/svgs/enterprise-solution-svgs/image04.jpg";
import image05 from "../assets/svgs/enterprise-solution-svgs/image05.jpg";
import image06 from "../assets/svgs/enterprise-solution-svgs/image06.jpg";
import image07 from "../assets/svgs/enterprise-solution-svgs/image07.jpg";
import image08 from "../assets/svgs/enterprise-solution-svgs/image08.jpg";
import image09 from "../assets/svgs/enterprise-solution-svgs/image09.jpg";
import image10 from "../assets/svgs/enterprise-solution-svgs/image10.jpg";
import image11 from "../assets/svgs/enterprise-solution-svgs/image11.jpg";
import AnimateOnDisplay from "../reusable/AnimateOnDisplay";
import ShakingBtn from "./animation/ShakingBtn";
import ImageWithAnimation from "./animation/ImageWithAnimation";
import SectionSubTitle from "../reusable/SectionSubTitle";
import HorizontalBorderWithnDisplayAnimation from "../reusable/HorizontalBorderWithnDisplayAnimation";

const EnterpriseSolutions = () => {
  const noOfComponentsToShowWhenCompressed = 4;
  const [isExpanded, setIsExpanded] = useState(false);
  const expandClicked = () => {
    setIsExpanded(true);
  };
  const compressClicked = () => {
    setIsExpanded(false);

    const element = document.getElementById(
      "lastEnterpriseSolutionWhenCompressed"
    );
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetY = rect.top + scrollTop;

    window.scrollTo({
      top: targetY,
      behavior: "smooth",
    });
  };

  return (
    <section id="enterpriseSolutions" className="bg-[#fff] text-[#111748]">
      <div className="pt-[5.1875em] pb-8 mobile:pb-12 tablet:pb-16 laptop:pb-32 space-y-3 tablet:space-y-6 laptop:space-y-9 desktop:space-y-12">
        <AnimateOnDisplay
          animationClass={"snap-in-"}
          className={`flex justify-center items-center`}
        >
          <div
            className={`-text-[40px] -tablet:text-[62.67px] -laptop:text-[85.33px] -desktop:text-[108px] font-40-to-108 enterprise-solution-section-title-animation uppercase leading-snug`}
          >
            <div className="text-[#111748] text-right font-[300] bg-yellow-600-">
              حلول
            </div>
            <div className="text-[#FFC641] text-left font-[900] bg-green-600-">
              المؤسسات
            </div>
          </div>
        </AnimateOnDisplay>
        <AnimateOnDisplay
          animationClass={"paragraph-animation"}
          screenPercentHeightToStartAnimation={90}
          className={"opacity-0"}
          animateEveryTime={false}
        >
          <p
            dir="rtl"
            className="text-[16px] tablet:text-[22px] laptop:text-[28px] desktop:text-[34px] font-[200] text-center mx-[10%] laptop:mx-[13.33%]"
          >
            نعمل على تمكين الشركات من خلال
            <span className="font-[600]">
              {" "}
              {""} حلول ذكية تدمج بين الذكاء الاصطناعي والاتصالات والأتمتة
              {""}{" "}
            </span>
            لتبسيط العمليات وتقليل التكاليف وتوسيع نطاق المشاركة. فتقنيتنا
            الحائزة على ثقة العلامات التجارية الرائدة
            <span className="font-[600]">
              {""} تقلب التعقيدات إلى نمو، وهو ما يمكّن
              {""}{" "}
            </span>
            الشركات من التكيف بشكل أسرع والريادة بثقة
            {/* نلتزم في PlanetBeyond بتزويد الشركات بالأدوات التي تلزمها لتحقيق
            النجاح في عرض رقمي سريع التطور. تهدف حلول المؤسسات لدينا إلى التعامل
            مع التحديات والفرص الخاصة التي تواجهها المؤسسات في سعيها وراء
            التميز. */}
            {/* في بلانىت بيوند،
            <span className="font-[500]">
              {" "}
              نحن ملتزمون بتزويد الشركات بالأدوات التي تحتاجها لتزدهر
            </span>{" "}
            في مشهد رقمي سريع التطور. تم تصميم حلول المؤسسات الخاصة بنا لمعالجة
            التحديات والفرص الفريدة التي تواجهها
            <span className="font-[500]">
              المؤسسات في سعيها لتحقيق التميز.
            </span>{" "} */}
          </p>
        </AnimateOnDisplay>
      </div>
      <div className="border-t-[1px]- border-[#11174833] text-[#111748]">
        <HorizontalBorderWithnDisplayAnimation borderColor={"#11174833"} />
        {servicesList.map(
          (service, i) =>
            (isExpanded || i < noOfComponentsToShowWhenCompressed) && (
              <div key={i}>
                <div
                  className="px-[5vw] tablet:px-16 py-[31px] min-h-[212px] flex flex-col-reverse gap-[21px] tablet:flex-row-reverse items-center justify-between border-b-[1px]- border-[#11174833]-"
                  id={
                    i === noOfComponentsToShowWhenCompressed - 1
                      ? "lastEnterpriseSolutionWhenCompressed"
                      : `enterpriseSolution${i}`
                  }
                >
                  <div className="flex justify-center items-center w-full ">
                    <div className="flex flex-row-reverse justify-center tablet:justify-normal items-baseline ">
                      <div className="w-[37px] text-center tablet:w-[5.625em]">
                        {service.no}
                      </div>
                      <div className="max-w-[80%] text-right">
                        {/* <p className="font-[900] text-[21px] tablet:text-[27.33px] laptop:text-[33.67px] desktop:text-[40px] uppercase leading-snug">
                        {service.title}
                      </p> */}
                        <SectionSubTitle
                          className={
                            "font-[900] text-right text-[21px] tablet:text-[27.33px] laptop:text-[33.67px] desktop:text-[40px] uppercase leading-snug"
                          }
                          animateEachLetterClass={"justify-end"}
                          text={service.title}
                        />
                        <AnimateOnDisplay
                          animationClass={"paragraph-animation"}
                          screenPercentHeightToStartAnimation={90}
                          className={"opacity-0"}
                          animateEveryTime={false}
                        >
                          {" "}
                          <p
                            dir="rtl"
                            className="font-[300] text-[16px] tablet:text-[22px] tablet:hidden"
                          >
                            <ExpandableText
                              noOfCharsWhenCompressed={134}
                              text={service.description}
                            />
                          </p>
                        </AnimateOnDisplay>
                        <AnimateOnDisplay
                          animationClass={"paragraph-animation"}
                          screenPercentHeightToStartAnimation={90}
                          className={"opacity-0"}
                          animateEveryTime={false}
                        >
                          {" "}
                          <p
                            dir="rtl"
                            className="font-[300] text-[21px] tablet:text-[22px] hidden tablet:block leading-snug"
                          >
                            {service.description}
                          </p>
                        </AnimateOnDisplay>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center item-center w-full tablet:w-auto">
                    <div
                      className="min-w-[90vw] max-w-[90vw] min-h-[239px]  
                    mobile:min-w-[450px] mobile:min-h-[300px] mobile:max-w-[450px] mobile:max-h-[300px] 
                tablet:min-w-[17.5em] tablet:min-h-[10.9375em] tablet:max-w-[17.5em] tablet:max-h-[10.9375em] "
                    >
                      <ImageWithAnimation
                        src={service.img}
                        animatingDivHeight={"400px"}
                      />
                      {/* <img
                      className="w-full h-full object-contain"
                      src={service.img}
                      alt="not found"
                    /> */}
                    </div>
                  </div>
                </div>
                <HorizontalBorderWithnDisplayAnimation
                  borderColor={"#11174833"}
                />
              </div>
            )
        )}
      </div>
      <div className="pt-[75px] pb-[156px] flex justify-center ">
        {isExpanded ? (
          <ShakingBtn>
            {" "}
            <button onClick={compressClicked} className={expandBtnClass}>
              طي الكل
            </button>
          </ShakingBtn>
        ) : (
          <ShakingBtn>
            {" "}
            <button onClick={expandClicked} className={expandBtnClass}>
              توسيع الكل
            </button>
          </ShakingBtn>
        )}
      </div>
    </section>
  );
};

const ExpandableText = ({ noOfCharsWhenCompressed, text }) => {
  const [isCompressed, setIsCompressed] = useState(true);
  const seeMoreClicked = () => {
    setIsCompressed(false);
  };
  const seeLessClicked = () => {
    setIsCompressed(true);
  };
  const textToShow = isCompressed
    ? text.slice(0, noOfCharsWhenCompressed) + "..."
    : text + ". ";
  const btn = isCompressed ? (
    <button className="text-[#111748] font-[500]" onClick={seeMoreClicked}>
      قراءة المزيد
    </button>
  ) : (
    <button className="text-[#111748] font-[500]" onClick={seeLessClicked}>
      اقرأ أقل
    </button>
  );
  return (
    <>
      {textToShow}
      {btn}
    </>
  );
};

export default EnterpriseSolutions;

const expandBtnClass =
  "border-[1px] border-[#11174833] rounded-[52px] text-[1em] text-center content-center px-7 py-3";

const servicesList = [
  {
    no: "١",
    title: "الذكاء الاصطناعي والأتمتة",
    description:
      "تستعين شركة Planet Beyond بالذكاء الاصطناعي لتوفير خدمة وكلاء التحاور، والمحتوى المُنشأ بالذكاء الاصطناعي، والتخصيص التنبؤي، والذكاء الاصطناعي الصوتي واللغوي، والأتمتة الذكية لسير العمل، وهو ما يساعد الشركات على زيادة مشاركة العملاء بشكل أذكى، والتوسع بشكل أسرع، وتحسين العمليات لتحقيق نمو قابل للقياس.",
    img: image01,
  },
  {
    no: "٢",
    title: "تحليلات البيانات",
    description:
      "توفر أدواتنا المتقدمة لتحليلات البيانات رؤى قيمة بشأن سلوك العملاء، واتجاهات السوق، والعمليات التجارية، وكل هذا يُمكِّن الشركات من اتخاذ قرارات مستنيرة تدفع عجلة النمو وتحقق عنصر الكفاءة. سواء كان الأمر يتعلق بتحليل التركيبة الديمغرافية للعملاء، أو التنبؤ باتجاهات السوق، أو تحسين إدارة سلسلة التوريد، فإن خدمات تحليل البيانات التي نقدمها تزود الشركات بالأدوات اللازمة لتحقيق الازدهار في عالم يعتمد على البيانات.",
    img: image02,
  },
  {
    no: "٣",
    title: "نمو الأنشطة التجارية عبر الإنترنت",
    description:
      "تساعد خدمات Planet Beyond لتنمية الأنشطة التجارية عبر الإنترنت الشركات على الازدهار في اقتصاد اليوم الرقمي من خلال صنع حضور قوي على الإنترنت وتنفيذ استراتيجيات تسويق رقمية فعالة. وتتضمن حلولنا تطوير المواقع الإلكترونية وتحسينها، وتحسين محركات البحث (SEO)، والتسويق عبر وسائل التواصل الاجتماعي، وتسويق المحتوى، والتسويق عبر البريد الإلكتروني، وغيرها من الخدمات المصممة لتلبية الاحتياجات الفريدة للشركات في المجالات المتنوعة.",
    img: image03,
  },
  {
    no: "٤",
    title: "منصة التسويق عبر الهاتف المحمول",
    description:
      "تُمكِّن منصة التسويق عبر الهاتف المحمول من شركة Planet Beyond الشركات من الوصول إلى العملاء واستقطابهم وإشراكهم عبر قنوات الهاتف المحمول من خلال الرسائل النصية القصيرة المخصصة والتسويق الذكي عبر التطبيقات، حيث تساعد المنصة العلامات التجارية على زيادة التفاعل إلى أقصى حد، وتعزيز الاحتفاظ، وتحويل التفاعلات إلى نمو قابل للقياس من خلال الإعلانات الموجهة والإشعارات المنبثقة",
    img: image04,
  },
  {
    no: "٥",
    title: "المكالمات والرسائل النصية القصيرة للشركات",
    description:
      "تعمل حلول المكالمات والرسائل النصية القصيرة للشركات من Planet Beyond على إزالة أوجه القصور في التواصل من خلال الاتصال المباشر والآمن والقابل للتوسيع مع العملاء، فبهذا يتم تبسيط المراسلات المؤسسية، وتحسين الوصول والانتشار، وتقليل التكاليف، وتعزيز الصلة بالعملاء لجعل التواصل مع الشركات أسرع وأكثر فاعلية",
    img: image05,
  },
  {
    no: "٦",

    title: "حل مركز الاتصال",
    description:
      "حل مركز الاتصال الذي نقدمه يساعد الشركات على الارتقاء بخدمة العملاء إلى مستويات غير مسبوقة من خلال توفير توجيه ذكي للمكالمات والاستجابة الصوتية التفاعلية وتسجيل المكالمات والتحليلات في الوقت الفعلي، حيث تعمل هذه الميزات على تمكين الشركات من توفير تجارب سلسة للعملاء، وحل المشكلات بكفاءة، وتحقيق نتائج أفضل للأعمال.",
    img: image06,
  },
  {
    no: "٧",

    title: "حل إدارة الولاء",
    description:
      "حل إدارة الولاء الذي نقدمه يساعد الشركات على بناء علاقات قوية مع العملاء من خلال تقديم المكافآت على المشاركة المتكررة، وتقسيم العملاء إلى شرائح حسب السلوك والتفضيلات، وتقديم مكافآت مخصصة تناسب كل فئة، وتتبع أداء البرنامج لتعزيز الولاء بما يحفز تكرار الشراء ويزيد الرضا العام",
    img: image07,
  },
  {
    no: "٨",

    title: "تكنولوجيا الإعلان والاتصالات متعددة القنوات",
    description:
      "تجمع مجموعة خدماتنا بين تكنولوجيا الإعلان المتقدمة واستراتيجيات القنوات المتعددة لمساعدة الشركات على الوصول إلى الجمهور المناسب في الوقت المناسب ومن خلال المنصة المناسبة، فبفضل ميزات مثل الإعلانات المبرمجة وإنشاء الإعلانات الديناميكية والتتبع عبر القنوات، تعمل حلول تكنولوجيا الإعلان التي نقدمها على زيادة العائد على الاستثمار الإعلاني إلى أقصى حد، وتحقيق نمو قابل للقياس في الأعمال التجارية.",
    img: image08,
  },
  {
    no: "٩",
    title: "خدمات العلامة البيضاء",
    description:
      "تعمل خدمات أتمتة العلامة البيضاء بالذكاء الاصطناعي من Planet Beyond على تمكين شركات الاتصالات من خلال تقديم حلول الرسائل النصية القصيرة المتكاملة بين الشركات وكلمات المرور لمرة واحدة، والتنبيهات، والامتثال، والفوترة، والدعم على مدار الساعة وطوال أيام الأسبوع بحيث يتم ضمان تقديم خدمات موثوقة وعمليات مبسطة وزيادة الإيرادات إلى أقصى حد، مع تسريع وتيرة تفاعلات العملاء لتحسين جودة الخدمة المقدمة ودفع عجلة نمو الأعمال.",
    img: image09,
  },
  {
    no: "١٠",
    title: "حلول اعرف عميلك إلكترونيًا",
    description:
      "يُحدث حل اعرف عميلك إلكترونيًا المقدم من شركة Planet Beyond ثورة في عملية دمج العملاء من خلال تمكين الشركات من التحقق من هويات عملائها رقميًا وبسرعة وأمان. وبفضل ميزات مثل التحقق الآلي من الهوية والتعرّف على الوجه والتحقق من صحة المستندات، يضمن حلنا الامتثال التنظيمي مع تقديم تجربة عملاء سلسة وجديرة بالثقة.",
    img: image10,
  },
  {
    no: "١١",
    title: "التطور طويل الأمد (LTE) الخاص",
    description:
      "توفر شبكات LTE الخاصة لدينا تغطية وسِعةً وموثوقية فائقة مقارنةً بشبكات Wi-Fi التقليدية أو الشبكات الخلوية العامة، فتكون بهذا مثالية للاستخدام مع تطبيقات مثل إنترنت الأشياء الصناعية والمدن الذكية والمقرات البعيدة وغيرها من البيئات ذات المهام الحرجة.",
    img: image11,
  },
];
